<template>
  <!-- eslint-disable max-len -->
  <div class="form-group" :class="{ 'array-border': border }">
    <slot name="title"><h6>Array Title Goes Here</h6></slot>
    <div
      v-if="sections && sections.length"
    >
      <collapsible-section
        v-model="sectionVisiblities[s]"
        v-for="(section, s) in sections"
        :key="`section-${s}`"
        :name="section.name"
        bold
        indent
        :buttonStyle="{
          'font-size': '130%'
        }"
      >
        <slot
          name="item"
          :item="item"
          :index="section.start + i"
          v-for="(item, i) in items.filter((it, ind) => (ind >= section.start && ind < section.end))"
        ></slot>
        <button
          v-if="section.end >= 0 && !(section.noButton)"
          class="btn my-2"
          @click.prevent="(event) => { add(event, section.end); }"
          :disabled="disabled">
          <span>Add {{section.name}}</span>
          <span v-if="disabled">&nbsp;(existing item missing required field)</span>
        </button>
      </collapsible-section>
    </div>
    <slot v-else name="item" :item="item" :index="i" v-for="(item, i) in items"></slot>
    <button
      v-if="!hideButton && !(sections && sections.length)"
      class="btn my-2"
      @click.prevent="add"
      :disabled="disabled">
      <slot name="button">Add</slot>
      <span v-if="disabled">&nbsp;(existing item missing required field)</span>
    </button>
    <template v-if="validator && validator.$error">
      <p class="error-msg" v-if="required && !validator.required">At least 1 item is required</p>
      <p class="error-msg" v-else-if="maxLength && !validator.maxLength">Must have no more than {{ maxLength }} items</p>
      <p class="error-msg" v-else-if="customError">{{ customError.message }}</p>
    </template>
  </div>
</template>

<script>
import { ObjectId } from 'bson';
import CollapsibleSection from './CollapsibleSection';

export default {
  components: {
    CollapsibleSection,
  },
  props: {
    items: { type: Array },
    stub: { type: Object, default: () => ({}) },
    disabled: { type: Boolean },
    hideButton: { type: Boolean },
    validator: { type: Object },
    required: { type: Boolean },
    maxLength: { type: Number },
    customErrors: { type: Array, default: () => [] },
    border: { type: Boolean },
    sections: { type: Array },
    generateId: { type: Boolean },
  },
  data() {
    return {
      sectionVisiblities: [],
      enableAutoexpand: false,
    };
  },
  computed: {
    customError() {
      return (this.customErrors || []).find(({ validator }) => (
        !this.validator[validator]
      ));
    }
  },
  methods: {
    add(_event, index) {
      const newItem = JSON.parse(JSON.stringify(this.stub));

      if (this.generateId) {
        newItem._id = (new ObjectId()).toString();
        console.log(newItem._id);
      }

      if (index == null || isNaN(index)) {
        this.items.push(newItem);
      } else {
        this.items.splice(index, 0, newItem);
      }
      if (this.validator) this.validator.$touch();
    },
  },
  created() {
    if (
      (this.required || this.maxLength || this.customErrors.length) &&
      this.validator
    ) {
      this.validator.$touch();
    }
    while (this.sections && this.sections.length
      && (this.sectionVisiblities.length < this.sections.length)) {
      this.sectionVisiblities.push(false);
    }
  },
  async mounted() {
    await new Promise(resolve => setTimeout(resolve, 250));
    this.enableAutoexpand = true;
  },
  watch: {
    sections(newValue, oldValue) {
      // console.log(oldValue);
      // console.log(newValue);
      while (newValue && newValue.length
        && (this.sectionVisiblities.length < newValue.length)) {
        this.sectionVisiblities.push(false);
      }
      for (let i = 0; i < newValue.length && i < oldValue.length; ++i) {
        const oldSpan = oldValue[i].end - oldValue[i].start;
        const newSpan = newValue[i].end - newValue[i].start;
        if (newSpan > 0 && newValue[i].start !== -1
          && (newSpan > oldSpan || oldValue[i].start === -1)) {
          // console.log(`expand ${newValue[i].name}`);
          if (this.enableAutoexpand) this.sectionVisiblities[i] = true;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.array-border {
  border-left: 1px solid #aaa;
  padding-left: 5px;
}
button.my-2 {
  padding-left: 8px;
  padding-right: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/inputs/ArrayInput.vue